import { Component, OnInit } from '@angular/core';
import { ScreenBreakpointObserverService } from '../../shared/foundation/utils/breakpoint-observer.service';

@Component({
  selector: 'app-layout-v2',
  templateUrl: './layout-v2.component.html',
  styleUrls: ['./layout-v2.component.scss'],
})
export class LayoutV2Component implements OnInit {
  isMobileLayout = false;

  constructor(private bpObserverService: ScreenBreakpointObserverService) {}

  ngOnInit(): void {
    this.bpObserverService.screenSizeObserver.subscribe({
      next: (res) => {
        if (res.length <= 2) {
          this.isMobileLayout = true;
        } else {
          this.isMobileLayout = false;
        }
      },
    });
  }
}
